module.exports = __webpack_public_path__ + "a686383fbe8dedeb05e352ede6bf2338.png";